import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape, propShape, propStr, } from '../../../helpers/custom-prop-types';
import { getFormErrorsFirst, getFormValue } from '../../../helpers/form';
import { validateOrganization, validateOrganizationOther, } from '../../../validate/profile';
import PlainInputField from '../Common/Fields/PlainInputField';
import SelectField from '../Common/Fields/SelectField';
import InputError from '../Common/InputError';
const OrganizationFieldsAndLabel = (props) => {
    const { form, name, nameOther, values } = props;
    if (values.length === 0) {
        return (_jsxs("div", Object.assign({ className: 'form form-solution' }, { children: [_jsx("h3", { children: "\u4F01\u696D\u540D" }), _jsx(PlainInputField, { disabled: true, name: 'company', placeholder: '' })] })));
    }
    const selectError = getFormErrorsFirst(form, [name]);
    const otherError = getFormErrorsFirst(form, [nameOther]);
    const positionValue = getFormValue(form, name);
    const isOther = positionValue === '0';
    const options = [
        { label: '選択してください', value: '' },
        ...values.map((row) => ({
            label: row.name,
            value: row.id,
        })),
        { label: 'その他', value: 0 },
    ];
    return (_jsxs("div", Object.assign({ className: 'form form-solution req' }, { children: [_jsx("h3", { children: "\u4F01\u696D\u540D" }), _jsxs("div", Object.assign({ className: 'form-flex-split is-half-form' }, { children: [_jsx("div", Object.assign({ className: 'input-form-select' }, { children: _jsx(SelectField, { className: 'form-solution-select set-option-height', name: name, options: options, validate: validateOrganization }) })), _jsx(PlainInputField, { className: 'input-form-text asign-state', disabled: !isOther, name: nameOther, showError: false, validate: isOther ? validateOrganizationOther : [] })] })), _jsx(InputError, { error: selectError || otherError })] })));
};
OrganizationFieldsAndLabel.propTypes = {
    form: propShape().isRequired,
    name: propStr().isRequired,
    nameOther: propStr().isRequired,
    values: propArrayShape().isRequired,
};
export default OrganizationFieldsAndLabel;
